module.exports = __webpack_public_path__ + "img/levelup_silver_notcompleted.9cfd67b2.svg";